'helper'.trashAll('Template')
'helper'.trashAll('Facet')
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.trashAll('Supplier')
'helper'.trashAll('POLine')
'helper'.trashAll('PO')
'helper'.trashAll('Configuration')
'helper'.trashAll('Currency')
'helper'.trashAll('NextNumber')
'helper'.trashAll('Payment')
'helper'.flushCache()
'helper'.checkNoDuplicateKeys()
'stocktend_settings'.click()
  'Enter Purchase Prices Inclusive of Tax'.shouldEqual('Yes')
  'Enter Purchase Prices Inclusive of Tax'.enter('No')
  'Default Tax %'.enter('10')
  'High Concurrency'.enter('Yes')
  'OK'.click()
'stocktend_settings'.click()
  'Currencies'.click()
    'Currencies'.shouldBeCurrentPage()
    'Add'.click()
      'Currency Code'.enter('USD')
      'Exchange Rate (Local amount times this equals Foreign amount)'.shouldEqual('1.0000')
      'Exchange Rate (Local amount times this equals Foreign amount)'.enter('0.6918')
      'OK'.click()
    'Add'.click()
      'Currency Code'.enter('EUR')
      'Exchange Rate (Local amount times this equals Foreign amount)'.enter('0.6167')
      'OK'.click()
    'mainTable./USD/.Exchange Rate'.shouldEqual('0.6918')
    'Back'.click()
  'OK'.click()
'helper'.checkNoDuplicateKeys()
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter("Castaways Inc")
      'Currency'.chooseOption('USD')
    'OK'.click()
    'helper'.checkNoDuplicateKeys()
  'Add'.click()
    'Name'.enter("Bombast Corporation")
    'OK'.click()
  'Back'.click()
'helper'.checkNoDuplicateKeys()
'stocktend_purchaseOrders'.click()
  'helper'.checkNoDuplicateKeys()
  'Add'.click()
    'helper'.checkNoDuplicateKeys()
    'Purchase Order Number'.enter('PO00001')
    'helper'.checkNoDuplicateKeys()
    'Currency'.shouldntExist()
    'Exchange Rate'.shouldntExist()
    'helper'.checkNoDuplicateKeys()
    'Supplier'.chooseOption('Castaways Inc')
    'helper'.checkNoDuplicateKeys()
    'Currency'.shouldEqual('USD')
    'Exchange Rate'.shouldEqual('0.6918')
    'Currency'.enter('EUR')
    'Exchange Rate'.shouldEqual('0.6167')
    'Currency'.enter('')
    'Exchange Rate'.shouldntExist()
    'Currency'.enter('USD')
    'Exchange Rate'.shouldEqual('0.6918')
    'Exchange Rate'.enter('0.7')
    'helper'.checkNoDuplicateKeys()
    'Supplier'.chooseOption('Bombast Corporation')
    'Currency'.shouldntExist()
    'Exchange Rate'.shouldntExist()
    'Supplier'.chooseOption('Castaways Inc')
    'Currency'.shouldEqual('USD')
    'Exchange Rate'.shouldEqual('0.6918')
    'Exchange Rate'.enter('0.7')
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'Quantity'.enter('10')
      'Unit Price (Inc Tax)'.shouldntExist()
      'Unit Price (Excl Tax)'.enter('90.9091')
      'Line Total (Inc Tax)'.shouldEqual('1,000.00')
      'Currency'.shouldEqual('USD')
      'Currency'.shouldBeReadOnly()
      'Avg Unit Cost (including this Order)'.shouldEqual('142.86')
      'OK'.click()
    'Order Total (Inc Tax)'.shouldEqual('1,000.00')
    'lines./Hoodie (H01)/.Description'.click()
      'Adjust Quantity On Hand'.click()
        'Product'.shouldEqual('Hoodie (H01)')
        'Back'.click()
      'Back'.click()
    'OK'.click()
  'mainTable.0.Edit'.click()
    'Payment Status'.shouldEqual('Unpaid')
    'Payment Status'.shouldntBeReadOnly()
    'Amount Outstanding'.shouldntExist()
    'Payments'.shouldntExist()
    'stocktend_settings'.click()
      'Supplier Payment Handling'.shouldEqual('Manually Mark POs as Paid')
      'Supplier Payment Handling'.enter('Multiple Payments Per PO')
      'OK'.click()
    'Payment Status'.shouldBeReadOnly()
    'Amount Outstanding'.shouldEqual('1,000.00')
    'Payments'.click()
      'Payments for Purchase Order PO00001'.shouldBeCurrentPage()
      'mainTable'.shouldBeEmpty()
      'Add'.click()
        'Add Payment'.shouldBeCurrentPage()
        'Payment Number'.shouldEqual('PO00001-P01')
        'Purchase Order'.shouldEqual('PO00001')
        'Payment Date'.shouldEqualExpression('global.todayLocal()')
        'Payment Date'.enterExpression('global.todayLocal().incDays(-3)')
        'Supplier'.shouldEqual('Castaways Inc')
        'Supplier'.shouldBeReadOnly()
        'Supplier Reference'.enter('CAST990')
        'Status'.shouldEqual('Paid')
        'Status'.enter('Unpaid')
        'Currency'.shouldEqual('USD')
        'Currency'.shouldBeReadOnly()
        'Amount'.shouldEqual('1000.00')
        'Amount'.enter('400')
        'Notes'.enter('Prepayment')
        'OK'.click()
      'mainTable./TOTAL/.Unpaid Amount'.shouldEqual('400.00')
      'mainTable./PO00001-P01/.Edit'.click()
        'Status'.enter('Paid')
        'OK'.click()
      'Add'.click()
        'Payment Number'.shouldEqual('PO00001-P02')
        'Payment Date'.enterExpression('global.todayLocal().incDays(7)')
        'Supplier Reference'.enter('CAST991')
        'Amount'.shouldEqual('600.00')
        'Status'.enter('Unpaid')
        'Notes'.enter('Final payment')
        'OK'.click()
      'mainTable'.shouldHaveCount(3) // Including Total
      'mainTable./TOTAL/.Paid Amount'.shouldEqual('400.00')
      'mainTable./TOTAL/.Unpaid Amount'.shouldEqual('600.00')
      'Back'.click()
    'Payment Status'.shouldEqual('Partially Paid')
    'Payments'.click()
      'mainTable./PO00001-P02/.Edit'.click()
        'Status'.enter('Paid')
        'OK'.click()
      'mainTable./TOTAL/.Paid Amount'.shouldEqual('1,000.00')
      'mainTable./TOTAL/.Unpaid Amount'.shouldEqual('0.00')
      'Back'.click()
    'Payment Status'.shouldEqual('Paid')
    'Payments'.click()
      'mainTable./PO00001-P02/.Trash'.click()
      'mainTable./PO00001-P02/.Really Trash?'.click()
      'Back'.click()
    'Payment Status'.shouldEqual('Partially Paid')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00002')
    'Supplier'.chooseOption('Castaways Inc')
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'Quantity'.enter('10')
      'Unit Price (Excl Tax)'.enter('90.9091')
      'OK'.click()
    'Order Total (Inc Tax)'.shouldEqual('1,000.00')
    'Payments'.click()
      'mainTable'.shouldHaveCount(0)
      'Back'.click()
    'OK'.click()
  'mainTable./PO00001/.Edit'.click()
    'Payments'.click()
      'mainTable'.shouldHaveCount(2) // including total
      'Back'.click()
    'OK'.click()
  'mainTable./PO00002/.Trash'.click()
  'mainTable./PO00002/.Really Trash?'.click()
  'Back'.click()
'helper'.checkNoDuplicateKeys()
'stocktend_reports'.click()
  'mainTable./Purchase Orders/.Run'.click()
    'mainTable.0.Line Total (Inc Tax)'.shouldEqual('1,428.57')
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00001/.Edit'.click()
    'Exchange Rate'.enter('0.6873')
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Orders/.Run'.click()
    'mainTable.0.Line Total (Inc Tax)'.shouldEqual('1,454.97')
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00001/.Edit'.click()
    'Currency'.enter('EUR')
    'Exchange Rate'.shouldEqual('0.6167')
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Orders/.Run'.click()
    'mainTable.0.Line Total (Inc Tax)'.shouldEqual('1,621.53')
    'Back'.click()
  'Back'.click()
'stocktend_receivePurchases'.click()
  'mainTable./PO00001/.Enter Receipt'.click()
    'Currency'.shouldEqual('EUR')
    'Currency'.shouldBeReadOnly()
    'Exchange Rate'.shouldEqual('0.6167')
    'Exchange Rate'.enter('0.62')
    'Lines'.shouldHaveCount(1)
    'Lines.0.Edit'.click()
      'Currency'.shouldEqual('EUR')
      'Currency'.shouldBeReadOnly()
      'Unit Price (Excl Tax)'.shouldEqual('90.9091')
      'Unit Price (Excl Tax)'.enter('81.8182')
      'Avg Unit Cost (including this Order)'.shouldEqual('145.16')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'helper'.checkNoDuplicateKeys()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00001/.Edit'.click()
    'Exchange Rate'.shouldEqual('0.6200')
    'Download PDF'.click()
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Avg Unit Cost'.shouldEqual('145.161323')
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('10')
  'Back'.click()
'stocktend_reports'.click()
  'searcher'.enter('s'); // To check it's enabled
  'Back'.click()
'stocktend_receivePurchases'.click()
  'View All Receipts'.click()
    'mainTable.0.Edit'.click()
      'Lines.0.Trash'.click()
      'Lines.0.Really Trash?'.click()
      'OK'.click()
    'Back'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('0')
  'Back'.click()
'stocktend_receivePurchases'.click()
  'View All Receipts'.click()
    'mainTable.0.Trash'.click()
    'mainTable.0.Really Trash?'.click()
    'Back'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('0')
  'Back'.click()
'stocktend_receivePurchases'.click()
  'mainTable./PO00001/.Enter Receipt'.click()
    'Exchange Rate'.enter('0.62')
    'Lines'.shouldHaveCount(1)
    'Lines.0.Edit'.click()
      'Unit Price (Excl Tax)'.enter('81.8182')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Avg Unit Cost'.shouldEqual('145.161323')
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('10')
  'Back'.click()
'stocktend_receivePurchases'.click()
  'View All Receipts'.click()
    'mainTable.0.Trash'.click()
    'mainTable.0.Really Trash?'.click()
    'Back'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('0')
  'Back'.click()
'helper'.trashAll('Template')
'helper'.trashAll('Facet')
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.trashAll('Supplier')
'helper'.trashAll('POLine')
'helper'.trashAll('PO')
'helper'.trashAll('Configuration')
'helper'.trashAll('NextNumber')
'helper'.flushCache()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.shouldEqual('PO00001')
    'stocktend_suppliers'.click()
      'Add'.click()
        'Name'.enter("Castaways Inc")
        'OK'.click()
      'Back'.click()
    'Purchase Order Number'.shouldEqual('PO00002')
    'Supplier'.enter('Castaways Inc')
    'Add Line'.click()
      'Purchase Order'.shouldEqual('PO00002')
      'Line Type'.enter('Fee')
      'OK'.click()
    'Back'.click()
  'mainTable.0.Trash'.click()
  'mainTable.0.Really Trash?'.click()
  'Back'.click()
'helper'.trashAll('Supplier')
'helper'.trashAll('POLine')
'helper'.trashAll('PO')
'helper'.flushCache()
'stocktend_settings'.click()
  'Business Name'.enter("Adventures in Wellness")
  'Phone Number'.enter('+613 9808 7125')
  'Email'.enter('bob@bob.com')
  'Address for Deliveries'.enter("45 Recently Way")
  'City/Suburb/Town'.enter("Geelong")
  'State/Province'.enter("VIC")
  'Postal/Zip Code'.enter("3220")
  'Country'.enter("Australia")
  'Short Date Format'.enter('dd/mm/yyyy')
  'OK'.click()
'stocktend_purchaseOrders'.click()
  'mainTable'._forEach('true', {lastToFirst: true})
    'Trash'.click()
    'Really Trash?'.click()
    'mainTable'.endForEach()
  'Back'.click()
'stocktend_suppliers'.click()
  'mainTable'._forEach('true', {lastToFirst: true})
    'Trash'.click()
    'Really Trash?'.click()
    'mainTable'.endForEach()
  'Add'.click()
    'Name'.enter("Castaways Inc")
    'Delivery Lead Days'.enter('7')
    'OK'.click()
  'Add'.click()
    'Name'.enter("Bombast Corporation")
    'OK'.click()
  'Back'.click()
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.clearWCStockLevels()
'helper'.flushCache()
'helper'.flushCache() //'Inventory'.click() // Infinite scroll tests start 'mainTable.50.Product'.shouldntEqual('') 'mainTable.51.Product'.shouldEqual('') 'mainTable.51'.scrollIntoView() 'mainTable.51.Product'.shouldntEqual('') 'mainTable.51.Product'.click() 'Edit Product'.shouldBeCurrentPage() 'Back'.click() 'mainTable.51.Product'.shouldntEqual('') 'browser'.back() // End of infinite scroll tests
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'Quantity'.enter('10')
      'OK'.click()
    'Inventory'.click()
      'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('10')
      'Back'.click()
    'OK'.click()
  'mainTable.0.Trash'.click()
  'mainTable.0.Really Trash?'.click()
  'Inventory'.click()
    'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('0')
    'Back'.click()
  'Add'.click()
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'Quantity'.enter('10')
      'OK'.click()
    'OK'.click()
  'Inventory'.click()
    'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('10')
    'Back'.click()
  'Receive Purchases'.click()
    'mainTable.1.Enter Receipt'.click()
      'OK'.click()
    'Back'.click()
  'Inventory'.click()
    'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('0')
    'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('10')
    'Back'.click()
  'Purchase Orders'.shouldBeCurrentPage()
  'mainTable.0.Trash'.click()
  'mainTable.0.Really Trash?'.click()
    'messageDialogText'.shouldEqual("Cannot trash this purchase order as there is a receipt for it: PO00004-01", 'doc')
    'OK'.click('doc')
  'mainTable.0.Edit'.click()
    'View Receipts'.click()
      'mainTable.0.Trash'.click()
      'mainTable.0.Really Trash?'.click()
      'Back'.click()
    'Back'.click()
  'helper'.checkNoDuplicateKeys()
  'mainTable.0.Trash'.click()
  'mainTable.0.Really Trash?'.click()
  'Inventory'.click()
    'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('0')
    'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('0')
    'Back'.click()
  'Purchase Orders'.shouldBeCurrentPage()
  'Add'.click()
    'Purchase Order Number'.enter('PO00001')
    'Supplier'.enter('xx')
    'Add Line'.click()
    'stFormRejection'.shouldContain('Invalid')
    'stFormRejection'.shouldContain('Supplier')
    'Expected Delivery Date'.shouldEqualExpression('global.todayLocal()')
    'Supplier'.chooseOption('Castaways Inc')
    'Expected Delivery Date'.shouldEqualExpression('global.todayLocal().incDays(7)')
    'Order Date'.enter('19/3/2020')
    'Expected Delivery Date'.shouldEqual('26/03/2020')
    'Deliver To'.shouldEqual('Adventures in Wellness, 45 Recently Way, Geelong, VIC 3220, Australia')
    'Deliver To'.enter('45 Recently Way, Geelong, VIC 3220')
    'Our Contact Details'.shouldEqual('+613 9808 7125, bob@bob.com')
    'OK'.click()
  'mainTable./PO00001/.Edit'.click()
    'Deliver To'.shouldEqual('45 Recently Way, Geelong, VIC 3220')
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00002')
    'Supplier'.chooseOption('Castaways Inc')
    'Order Date'.enter('17/3/2020')
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00003')
    'Supplier'.chooseOption('Bombast Corporation')
    'Order Date'.enter('28/2/2020')
    'Add Line'.click()
      'Product'.enter("xxxx")
      'Description'.enter("x")
      'OK'.click()
      'stFormRejection'.shouldContain("Invalid")
      'stFormRejection'.shouldContain("Product")
      'Product'.chooseOption("Vneck Tshirt (V01)")
      'Description'.shouldEqual('Vneck Tshirt')
      'OK'.click()
    'Add Line'.click()
      'Description'.shouldEqual('')
      'Line Type'.shouldEqual('Product')
      'Product'.shouldExist()
      'Line Type'.clickDropdown()
      'Line Type'.shouldHaveOption('Product')
      'Line Type'.shouldHaveOption('Shipping')
      'Line Type'.shouldHaveOption('Fee')
      'Line Type'.shouldHaveOption('Tax')
      'Line Type'.shouldHaveOption('Other')
      'Line Type'.chooseOption('Shipping')
      'Product'.shouldntExist()
      'Delivery'.shouldntExist()
      'Cancelled Quantity'.shouldntExist()
      'Description'.shouldEqual('Shipping')
      'Line Type'.chooseOption('Other')
      'Description'.shouldEqual('')
      'Line Type'.chooseOption('Product')
      'Product'.shouldExist()
      'Delivery'.shouldExist()
      'Cancelled Quantity'.shouldExist()
      'Line Type'.chooseOption('Shipping')
      'Description'.shouldEqual('Shipping')
      'Product'.shouldntExist()
      'Description'.enter('Discount shipping as agreed')
      'Quantity'.shouldEqual('1')
      'Unit Price (Inc Tax)'.enter('35.50')
      'OK'.click()
    'Lines.0.Description'.shouldEqual('Vneck Tshirt (V01)')
    'Lines.1.Description'.shouldEqual('Discount shipping as agreed')
    'Download PDF'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('Search Me')
    'Order Date'.enter('1/1/2020')
    'OK'.click()
  'mainTable'.shouldHaveCount(4)
  'searcher'.key('M')
  'searcher'.key('a')
  'searcher'.key('r')
  'mainTable'.shouldHaveCount(2)
  'searcher'.key(' ')
  'searcher'.key('1')
  'searcher'.key('9')
  'mainTable'.shouldHaveCount(1)
  'searcherClear'.click()
  'mainTable'.shouldHaveCount(4)
  'searcher'.key('s')
  'searcher'.shouldEqual('s')
  'searcher'.key('e')
  'mainTable'.shouldHaveCount(1)
  'mainTable.0.Purchase Order Number'.shouldEqual('Search Me')
  'searcher'.key('<Backspace>')
  'searcher'.key('<Backspace>')
  'mainTable'.shouldHaveCount(4)
  'searcher'.key('p')
  'mainTable'.shouldHaveCount(3)
  'searcher'.key('O')
  'searcher'.key('0')
  'searcher'.key('0')
  'searcher'.key('0')
  'searcher'.key('0')
  'mainTable'.shouldHaveCount(3)
  'searcher'.key('1')
  'searcher'.shouldEqual('pO00001')
  'mainTable'.shouldHaveCount(1)
  'mainTable.0.Purchase Order Number'.shouldEqual('PO00001')
  'searcher'.key('<Backspace>')
  'mainTable'.shouldHaveCount(3)
  'searcherClear'.click()
  'searcher'.shouldEqual('')
  'mainTable'.shouldHaveCount(4)
  'searcher'.key('b')
  'mainTable'.shouldHaveCount(1)
  'mainTable.0.Supplier'.shouldEqual('Bombast Corporation')
  'searcher'.key('<Backspace>')
  'mainTable'.shouldHaveCount(4)
  'searcher'.key('c')
  'searcher'.key('a')
  'mainTable'.shouldHaveCount(2)
  'mainTable.0.Supplier'.shouldEqual('Castaways Inc')
  'stocktend_purchaseOrders'.click()
'helper'.checkNoDuplicateKeys()
'searcherClear'.click()
'helper'.trashAll('PO')
'helper'.trashAll('Avenue')
'helper'.trashAll('Supplier')
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Add Purchase Order'.shouldBeCurrentPage()
    'Purchase Order Number'.shouldMatch('PO[0-9]*')
    'browser'.back()
  'mainTable'.shouldHaveCount(0)
  'Add'.click()
    'Add Purchase Order'.shouldBeCurrentPage()
    'Purchase Order Number'.shouldMatch('PO[0-9]*')
    'Back'.click()
  'Purchase Orders'.shouldBeCurrentPage()
  'mainTable'.shouldHaveCount(0)
  'Add'.click()
    'Add Purchase Order'.shouldBeCurrentPage()
    'Purchase Order Number'.shouldMatch('PO[0-9]*')
    'Order Date'.shouldEqualExpression('global.todayLocal()')
    'Order Date'.enterExpression('global.todayLocal().incDays(-3)')
    'Order Date'.shouldEqualExpression('global.todayLocal().incDays(-3)')
    'Purchase Order Number'.enter('PO00002')
    'Status'.shouldEqual('Awaiting Delivery')
    'Status'.shouldBeReadOnly()
    'Add Line'.click()
      'Add Purchase Order Line'.shouldBeCurrentPage()
      'browser'.back()
    'confirmLeave'.shouldntExist('doc')
    'Lines'.shouldHaveCount(0)
    'Add Line'.click()
      'Add Purchase Order Line'.shouldBeCurrentPage()
      'Back'.click()
    'confirmLeave'.shouldntExist('doc')
    'Lines'.shouldHaveCount(0)
    'Add Line'.click()
      'Add Purchase Order Line'.shouldBeCurrentPage()
      'Product'.chooseOption('Shórts - Blue (SB01)')
      'Back'.click()
      'confirmLeave'.shouldExist('doc')
      'No - Stay on this page'.click('doc')
      'browser'.back()
      'Back'.click()
      'Yes - Cancel my changes'.click('doc')
    'Add Purchase Order'.shouldBeCurrentPage()
    'Lines'.shouldHaveCount(0)
    'Add Line'.click()
      'Purchase Order'.shouldEqual('PO00002')
      'Purchase Order'.shouldBeReadOnly()
      'Product'.chooseOption('Shórts - Blue (SB01)')
      'Quantity'.enter('text')
      'Quantity'.shouldHaveError('must be a number')
      'Quantity'.enter('2')
      'Save'.click()
      'Edit Purchase Order Line'.shouldBeCurrentPage()
      'Quantity'.enter('1')
      'OK'.click()
    'Add Purchase Order'.shouldBeCurrentPage()
    'OK'.click()
  'Purchase Orders'.shouldBeCurrentPage()
'mainTable'.shouldHaveCount(1)
'mainTable.0.Order Date'.shouldEqualExpression('global.todayLocal().incDays(-3).toLocalMMMDY()')
'mainTable.0.Edit'.click()
'Edit Purchase Order'.shouldBeCurrentPage()
'Lines'.shouldHaveCount(1)
'stocktend_suppliers'.click()
'Add'.click()
'Add Supplier'.shouldBeCurrentPage()
'Name'.enter('Acme Enterprises')
'Save'.click()
'Edit Supplier'.shouldBeCurrentPage()
'OK'.click()
'Suppliers'.shouldBeCurrentPage()
'mainTable'.shouldHaveCount(1)
'mainTable.0.Trash'.click()
'mainTable.0.Really Trash?'.click()
'mainTable'.shouldHaveCount(0)
'Add'.click()
'Add Supplier'.shouldBeCurrentPage()
'Name'.enter('Acme Enterprises')
'Add another'.click()
'Name'.enter('Bombast Corporation')
'Address'.enter("1000000 Bombastic Way")
'City/Suburb/Town'.enter("West Gloam")
'State/Province'.enter("Quebec")
'Postal/Zip Code'.enter("12345")
'Country'.enter("Canada")
'Add another'.click()
'Name'.enter('Castaways {"Aust,"}')
'Save'.click()
'stocktend_purchaseOrders'.click()
'mainTable'._forEach('true', {lastToFirst: true})
  'Trash'.click()
  'Really Trash?'.click()
  'mainTable'.endForEach()
'Inventory'.click()
'searcher'.enter('S')
'mainTable./Shórts - Red (SR01)/.On Purchase Orders'.shouldEqual('0')
'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('0')
'searcher'.enter('H')
'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('0')
'stocktend_purchaseOrders'.click()
'Add'.click()
'Add Purchase Order'.shouldBeCurrentPage()
'Purchase Order Number'.enter('PO00002')
'Order Date'.enterExpression('global.todayLocal().incDays(-3)')
'Lines'.shouldHaveCount(0)
'Supplier'.clickDropdown()
'Supplier'.shouldHaveNOptions(4) // counting blank
'Supplier'.chooseOption('Castaways {"Aust,"}')
'Add Line'.click()
'Add Purchase Order Line'.shouldBeCurrentPage()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Quantity'.enter('text')
'Quantity'.shouldHaveError('must be a number')
'Quantity'.enter('1')
'Quantity'.shouldntHaveError()
'OK'.click()
'Add Purchase Order'.shouldBeCurrentPage()
'Supplier'.shouldEqual('Castaways {"Aust,"}')
'Lines'.shouldHaveCount(1)
'Add Line'.click()
'Product'.chooseOption('Cap (C01)')
'Quantity'.enter('2')
'OK'.click()
'Add Purchase Order'.shouldBeCurrentPage()
'Lines'.shouldHaveCount(2)
'Lines.0.Edit'.click()
'Product'.shouldEqual('Shórts - Blue (SB01)')
'Quantity'.shouldEqual('1')
'stocktend_purchaseOrders'.click()
'mainTable'.shouldHaveCount(1)
'mainTable.0.Supplier'.shouldEqual('Castaways {"Aust,"}')
'mainTable.0.Edit'.click()
'Edit Purchase Order'.shouldBeCurrentPage()
'Lines.1.Edit'.click()
'Edit Purchase Order Line'.shouldBeCurrentPage()
'browser'.back()
'confirmLeave'.shouldntExist('doc')
'Lines.1.Edit'.click()
'Edit Purchase Order Line'.shouldBeCurrentPage()
'Back'.click()
'confirmLeave'.shouldntExist('doc')
'Edit Purchase Order'.shouldBeCurrentPage()
'Lines.1.Edit'.click()
'Product'.shouldEqual('Cap (C01)')
'Product'.chooseOption('Shórts - Red (SR01)')
'Back'.click()
'confirmLeave'.shouldExist('doc')
'Yes - Cancel my changes'.click('doc')
'Lines.1.Edit'.click()
'Product'.shouldEqual('Cap (C01)')
'Product'.chooseOption('Shórts - Red (SR01)')
'browser'.back()
'confirmLeave'.shouldExist('doc')
'Yes - Cancel my changes'.click('doc')
'Lines.1.Edit'.click()
'Product'.shouldEqual('Cap (C01)')
'Product'.chooseOption('Shórts - Red (SR01)')
'Quantity'.shouldEqual('2')
'Quantity'.enter('3')
'Save'.click()
'Edit Purchase Order Line'.shouldBeCurrentPage()
'OK'.click()
'Edit Purchase Order'.shouldBeCurrentPage()
'helper'.checkNoDuplicateKeys()
'Lines'.shouldHaveCount(2)
'Lines.1.Description'.shouldEqual('Shórts - Red (SR01)')
'Lines.1.Quantity'.shouldEqual('3')
'Lines.0.Trash'.click()
'Lines.0.Really Trash?'.click()
'Lines'.shouldHaveCount(1)
'Add another'.click()
'helper'.checkNoDuplicateKeys()
'Purchase Order Number'.shouldMatch('PO[0-9]*')
'Purchase Order Number'.enter('PO00002')
'Purchase Order Number'.shouldHaveError('Purchase Order')
'Purchase Order Number'.shouldHaveError('already exists')
'Purchase Order Number'.enter('PO00003')
'Supplier'.chooseOption('Bombast Corporation')
'Add Line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Quantity'.enter('1')
'Add another line'.click()
'Product'.chooseOption('Hoodie (H01)')
'Quantity'.enter('10')
'Add another line'.click()
'Product'.chooseOption('Shórts - Red (SR01)')
'Quantity'.enter('2')
'OK'.click()
'Add Purchase Order'.shouldBeCurrentPage()
'Lines'.shouldHaveCount(3)
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.On Purchase Orders'.shouldEqual('5')
'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('1')
'searcher'.enter('h')
'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('10')
'stocktend_purchaseOrders'.click()
'mainTable'.shouldHaveCount(2)
'mainTable.1.Supplier'.shouldEqual('Castaways {"Aust,"}')
'mainTable.0.Edit'.click()
'Purchase Order Number'.shouldEqual('PO00003') // due to default sort order being reverse date sequence
'browser'.back()
'mainTable.1.Edit'.click()
'Purchase Order Number'.shouldEqual('PO00002')
'stocktend_suppliers'.click()
'mainTable'.shouldHaveCount(3)
'mainTable./Castaways {"Aust,"}/.Trash'.click()
'mainTable./Castaways {"Aust,"}/.Really Trash?'.click()
'messageDialog'.shouldExist('doc')
'messageDialogText'.shouldExist('doc')
'messageDialogText'.shouldContain("Supplier has been referenced on Purchase Order PO0000", 'doc')
'messageDialogText'.shouldContain("and so cannot be trashed", 'doc')
'OK'.click('doc')
'mainTable'.shouldHaveCount(3)
'stocktend_purchaseOrders'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00004')
'Supplier'.chooseOption('Bombast Corporation')
'Add another'.click()
'Purchase Order Number'.enter('PO00005')
'Supplier'.chooseOption('Castaways {"Aust,"}')
'Save'.click()
'Edit Purchase Order'.shouldBeCurrentPage()
'Supplier'.chooseOption('Bombast Corporation')
'OK'.click()
'Purchase Orders'.shouldBeCurrentPage()
'mainTable./PO00004/.Supplier'.shouldEqual('Bombast Corporation')
'mainTable./PO00005/.Supplier'.shouldEqual('Bombast Corporation')
'Add'.click()
'Supplier'.chooseOption('Bombast Corporation')
'Notes For Supplier'.enter("Just some notes about this order - ******please deliver only on the second Tuesday following a blue blood moon")
'Add Line'.click()
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Sunglasses (SG01)')
'Add another line'.click()
'Product'.chooseOption('Cap (C01)')
'Add another line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'OK'.click()
'Lines./Shórts - Blue (SB01)/'.shouldBeInView()
'Lines./Shórts - Blue (SB01)/.Trash'.click()
'Lines./Shórts - Blue (SB01)/.Really Trash?'.click()
'Lines./Cap (C01)/.Edit'.click()
'OK'.click()
'Lines./Cap (C01)/'.shouldBeInView()
'Download PDF'.click()
'Add another'.click()
'Purchase Order Number'.enter('POScrollTest1')
'Order Date'.enterExpression('global.todayLocal().incDays(-1)')
'Add another'.click()
'Add another'.click()
'stocktend_purchaseOrders'.click()
'Add'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Add another'.click()
'Purchase Order Number'.enter('POScrollTest2')
'Order Date'.enterExpression('global.todayLocal().incDays(1)')
'OK'.click()
'mainTable./POScrollTest1/'.shouldntBeInView()
'mainTable./POScrollTest1/'.scrollIntoView()
'mainTable./POScrollTest1/'.shouldBeInView()
'mainTable./POScrollTest1/.Edit'.click()
'Back'.click()
'mainTable./POScrollTest1/'.shouldBeInView()
'mainTable./POScrollTest2/'.shouldntBeInView()
'Add'.click()
'Purchase Order Number'.enter('POScrollTest3')
'Order Date'.enterExpression('global.todayLocal().incDays(2)')
'OK'.click() 
'mainTable./POScrollTest3/'.shouldBeInView()
'stocktend_purchaseOrders'.click()
'mainTable.<columnHeadings>.Supplier'.click()
'mainTable.0.Supplier'.shouldEqual('')
'mainTable.<last>.Supplier'.shouldMatch('Castaway.*')
'mainTable.<columnHeadings>.Supplier'.click()
'mainTable.0.Supplier'.shouldMatch('Castaway.*')
'mainTable.1.Supplier'.shouldMatch('Bombast.*')
'mainTable.<last>.Supplier'.shouldEqual('')
'mainTable.0.Trash'.click()
'mainTable.0.Really Trash?'.click()
'mainTable.0.Supplier'.shouldMatch('Bombast.*') // i.e. sort order shouldn't have changed
'helper'.checkNoDuplicateKeys()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.On Purchase Orders'.shouldEqual('2')
'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('1')
'searcher'.enter('h')
'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('10')
